import type { VersionNotificationProps } from '../components/Notification';

import Truncate from '@ui/Truncate';

import VersionNotification from '../components/Notification';
import useBuildBranchPath from '../hooks/useBuildBranchPath';

interface ErrorProps {
  apiError: VersionNotificationProps['apiError'];
  name: string;
}

export function BranchErrorNotification({ apiError, name }: ErrorProps) {
  return (
    <VersionNotification
      apiError={apiError}
      description={
        <>
          Failed to create <Truncate maxWidth={100}>v{name}</Truncate>. Please try again or{' '}
          <a href="mailto:support@readme.io" rel="noreferrer" target="_blank">
            reach out to support
          </a>
          .
        </>
      }
      kind="error"
      title="Problem Creating Branch"
    />
  );
}

export function BranchSuccessNotification({ name }: { name: string }) {
  const buildBranchPath = useBuildBranchPath();

  return (
    <VersionNotification
      description={
        <>
          <Truncate maxWidth={100}>v{name}</Truncate> has been created.{' '}
          <a href={buildBranchPath(name)} rel="noreferrer">
            View now
          </a>
        </>
      }
      kind="success"
      title="Branch Created"
    />
  );
}
